import {createDetailResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const TerminalSchema = z.object({
  terminalId: z.string(),
  no: z.string().nullable(),
  lastTransactionDate: z.string().nullable(),
  deviceModel: z.string().nullable(),
  manufacturer: z.string().nullable(),
  deviceOS: z.string().nullable(),
  deviceLabel: z.string().nullable(),
  serialNumber: z.string().nullable(),
  oneTimePasscode: z.string().nullable(),
  assignedBuildNumber: z.string().nullable(),
  buildNumber: z.string().nullable(),
  applicationSign: z.string().nullable(),
  mccCode: z.string().nullable(),
  storeId: z.string().nullable(),
  storeNo: z.string().nullable(),
  tokenCode: z.string().nullable(),
  transactionDetails: z.array(
    z.object({
      orderId: z.string().nullable(),
      date: z.string(),
      posNo: z.string(),
      type: z.any(),
      discountAmount: z.number(),
      feeAmount: z.number(),
      paidAmount: z.number(),
      purchaseAmount: z.number(),
      pointEarned: z.number(),
      pointReedemption: z.number(),
      totalAmount: z.number(),
      channel: z.any(),
      storeNo: z.string(),
      terminalId: z.string(),
      transactionId: z.string(),
    })
  ),
  detailsPaging: z.object({
    currentPageNumber: z.number(),
    totalPagesNumber: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
})

export const TerminalSchemaResponse = createDetailResponseSchema(TerminalSchema)

export type Terminal = z.infer<typeof TerminalSchema>
export type TerminalResponse = z.infer<typeof TerminalSchemaResponse>
